const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://todo-api.chengsht.workers.dev';
console.log('Current API URL:', API_BASE_URL);

export const todoApi = {
  // 获取所有待办事项
  getAllTodos: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/todos`);
      if (!response.ok) throw new Error('获取待办事项失败');
      return await response.json();
    } catch (error) {
      console.error('获取待办事项错误:', error);
      throw error;
    }
  },

  // 添加待办事项
  createTodo: async (todoText) => {
    try {
      const response = await fetch(`${API_BASE_URL}/todos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text: todoText, completed: false }),
      });
      if (!response.ok) throw new Error('添加待办事项失败');
      return await response.json();
    } catch (error) {
      console.error('添加待办事项错误:', error);
      throw error;
    }
  },

  // 更新待办事项状态
  updateTodo: async (id, updates) => {
    try {
      const response = await fetch(`${API_BASE_URL}/todos/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      });
      if (!response.ok) throw new Error('更新待办事项失败');
      return await response.json();
    } catch (error) {
      console.error('更新待办事项错误:', error);
      throw error;
    }
  },

  // 删除待办事项
  deleteTodo: async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/todos/${id}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('删除待办事项失败');
      return await response.json();
    } catch (error) {
      console.error('删除待办事项错误:', error);
      throw error;
    }
  },
}; 